import { render, staticRenderFns } from "./recoveryByMail.vue?vue&type=template&id=46fa31ba&"
import script from "./recoveryByMail.vue?vue&type=script&lang=js&"
export * from "./recoveryByMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports